import { controller } from "./controller";

@controller
export default class XaBindTextElement extends HTMLElement {
  connectedCallback(): void {
    setTimeout(() => {
      this.init();
    });
  }

  init(): void {
    if (this.getAttribute("type") === "currency" && this.textContent) {
      this.textContent = this._inputOnInputHandler(this.textContent.trim());
    } else if (
      this.getAttribute("type") === "customUserInput" &&
      (this.textContent?.trim() === "YES" || this.textContent?.trim() === "")
    ) {
      this.textContent = "N/A";
    } else if (this.getAttribute("type") === "optional" && this.textContent?.trim() === "") {
      this.textContent = "N/A";
    } else if (
      this.getAttribute("type") === "date" &&
      this.textContent &&
      this.textContent.trim() !== "" &&
      new Date(this.textContent?.trim()).getTime()
    ) {
      this.textContent = new Intl.DateTimeFormat("en-US").format(new Date(`${this.textContent?.trim()}T00:00:00`));
    }
  }
  _inputOnInputHandler(value: string): string {
    const formatter = new Intl.NumberFormat("en-US", {
      currency: "USD",
      style: "currency",
    });
    if (!value) return value;

    return formatter.format(Number(value));
  }
}

declare global {
  interface Window {
    XaBindTextElement: typeof XaBindTextElement;
  }
  interface HTMLElementTagNameMap {
    "bind-text": XaBindTextElement;
  }
}

if (!window.customElements.get("bind-text")) {
  window.XaBindTextElement = XaBindTextElement;
  window.customElements.define("bind-text", XaBindTextElement);
}
